/**
 * WHAT AN ACCEPTANCE RECORDS (23 Oct 2026, Minto P-1026-10296).
 *
 * Rob accepted by phone; Jacky's Record acceptance was refused twice: "This Proposal lets the customer choose per room: record the
 * acceptance of the released customer copy (v56) … the working draft is not what they agreed to." The panel always sent the
 * working draft and its builder pricing. For an open-book or room-choice Proposal the customer only ever saw the RELEASED copy,
 * priced from their own saved choice — so that is what an acceptance freezes, and what the panel must show before the click.
 * Every other Proposal records its saved working version at the builder's price, as before.
 */
import {CustomerPricing,CustomerSelection,RoomChoiceOffer,priceRoomChoice,roomChoiceSelectionDrift} from '@artemis-group/aiw-contracts';

export type AcceptanceDocument={version?:number|null;published_version:number|null;published:{pricing?:unknown}|null};

export type AcceptanceTarget=
 |{mode:'issued';version:number;pricing:CustomerPricing|null;laterEdits:boolean;drift:{recommended:number;chosen:number;rooms:string[]}|null}
 |{mode:'working'};

export function acceptanceTarget(document:AcceptanceDocument|null|undefined,selection:unknown,workingVersion?:number|null):AcceptanceTarget{
 const pricing=document?.published?.pricing as {room_choice?:unknown;open_book?:unknown}|undefined;
 if(!document?.published_version||!pricing||(!pricing.room_choice&&!pricing.open_book))return {mode:'working'};
 const laterEdits=(workingVersion??document.version??document.published_version)>document.published_version;
 if(pricing.room_choice){
  const offer=RoomChoiceOffer.safeParse(pricing.room_choice).data,chosen=CustomerSelection.safeParse(selection??{}).data??null;
  if(offer)return {mode:'issued',version:document.published_version,pricing:priceRoomChoice(offer,chosen),laterEdits,drift:roomChoiceSelectionDrift(offer,chosen)};
 }
 // Open-book: the command prices the released offer from the customer's saved choice; the panel shows the released copy's figure.
 return {mode:'issued',version:document.published_version,pricing:CustomerPricing.safeParse(pricing).data??null,laterEdits,drift:null};
}
